import React from "react";
import { Form, Col } from "react-bootstrap";

const defaultTemplate = function(value) {
  return (
    <Col
      style={{ maxWidth: value.label == "Under Construction" ? "30%" : "44%" }}
    >
      <Form.Check>
        <Form.Check.Input {...value} />
        <Form.Check.Label>{value.label}</Form.Check.Label>
      </Form.Check>
    </Col>
  );
};

export function GroupFields(props) {
  const {
    options = [],
    keyName = "",
    type = "radio",
    name = "",
    events = {},
    Template = defaultTemplate,
    projectImplementationStartState
  } = props;
  return (
    <>
      <Form.Row as={Col} key={type} data-key={keyName} {...events}>
        {options.map((value, index) => (
          <Template {...value} data-key={keyName} type={type} name={name} />
        ))}
      </Form.Row>
    </>
  );
}
